import React from 'react';

import { P } from '../P/P';
import { Section } from './Section';
import { UL } from './UL';
import { LI } from './LI';
import { ExternalLink } from './ExternalLink';

// eslint-disable-next-line camelcase
export const LE4_2b = () => (
  <Section>

    <UL disc>
      <LI>
        <P gapAfter>
          Verwertung: Recycling, Upcycling, Secondhand, Tausch, Selfmade (reparieren, selbst nähen/ändern), Kleidersammlung, illegale Kleidersammlung, illegale Altkleider-Container, FairWertung
        </P>
        <UL square>
          <LI>
            Instagram-Mode-Blog der Berlinerinnen Karina Papp & Anna Vladi: found_on_the_ street
            (mit Kleidung, die auf Berliner Straßen gefunden wurde),
            Kleidersammlung, illegale Kleidersammlung, illegale Altkleider-Container, FairWertung
          </LI>
        </UL>
      </LI>
      <LI>
        <P gapBefore gapAfter>
          Beschaffung: Fair Fashion (u. a.: Shops/Siegel)
        </P>
        <UL square>
          <LI>
            Blogger Riccardo versucht fair zu kaufen:&nbsp;
            <ExternalLink href="https://www.br.de/puls/tv/puls/faire-mode-pro-und-contra-100.html" />
          </LI>
          <LI>
            Artikel: Interview mit Mimi Sewalski &#8222;Große Konzerne erfinden oft eigene faire Siegel&rdquo;:<br />
            <ExternalLink href="https://www.br.de/puls/themen/leben/mimi-sewalski-interview-avocado-store-fast-fashion-100.html" />
            (BR, 2016)
          </LI>
          <LI>
            BMZ/GIZ: Siegelklarheit. Informationen zu den verschiedenen Siegeln und Standards der Textilindustrie:&nbsp;
            <ExternalLink href="https://www.siegelklarheit.de" />
          </LI>
          <LI>
            Label-Porträts ab Seite 26:&nbsp;
            <ExternalLink href="https://saubere-kleidung.de/wp-content/uploads/2018/10/menschenrechte_textilindustrie_2018.pdf" />
            <br />
            Was machen die Labels anders als herkömmliche Mode-Labels? Was sind die Herausforderungen (wirtschaftliche Aspekte, Marketing etc.)?
          </LI>
          <LI>
            Fair-Shopping-Tipps: APPs, Labels und Siegel<br />
            <ExternalLink href="https://www.br.de/puls/themen/leben/fair-shoppen-tipps-100.html" />
          </LI>
          <LI>
            Einkaufsratgeber von Greenpeace für giftfreie Mode:<br />
            <ExternalLink href="https://www.greenpeace.de/sites/www.greenpeace.de/files/greenpeace_textil-label-juni_2016.pdf" />
          </LI>
          <LI>
            Tipps, wie und wo Käufer und VerbraucherInnen sich engagieren können: Ratgeber Textilsiegel<br />
            <ExternalLink href="https://saubere-kleidung.de/wp-content/uploads/2018/10/menschenrechte_textilindustrie_2018.pdf" />
          </LI>
          <LI>
            Wie ich seit zwei Jahren ohne Fast Fashion lebe (Berliner Zeitung vom 07.02.2019):<br />
            <ExternalLink href="https://www.berliner-zeitung.de/ratgeber/nachhaltigkeit/so-lebe-ich-seit-zwei-jahren-ohne-fast-fashion-31948096" />
          </LI>
        </UL>
      </LI>
    </UL>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE4_2b.js